import React, { useEffect, useState } from 'react';
import { commonService } from '_services/common.service';
import { Row, Col, Card, Button } from "reactstrap";
import { Link } from "react-router-dom";

const Newssection = () => {
    const [state, setState] = useState({
        news: []
    });

    useEffect(() => {
        getNewsdata();
    }, []);
    const getNewsdata = async () => {
       
        let news = await commonService.getServices('/publicChannel/news/0/6').catch(err => console.log('err', err));

        if (news) {
            //console.log("news:", news);
            state.news = news.data.results?news.data.results?.slice(0, 6):[];
            setState({ ...state });
        }
    }
    return (
        <Card className='m-0' id='new-home-page-padding' style={{ backgroundColor:"#fff"}}>
          <div
            style={{
              fontSize: "1.2rem",
              textAlign: "center",
              color: "rgb(50, 50, 93)",
              fontWeight: "600",
              paddingBottom:"3rem",
              backgroundColor: "#fff",
              fontFamily: "inherit",
            }}
          >
Channel news & market insights
          </div>
            <div style={{ backgroundColor: "#fff"}} id='dashslide'>

                <Row className="d-flex justify-content-center">
                    {state.news.map(x =>
                        <Col xl="4" lg="4" md="6" sm="12" xs="12" style={{paddingLeft:"20px", paddingRight:"20px"}}>
                            <a href={x.url} target='_blank'>
                                <Card style={{margin:"0 0 2.5rem 0", backgroundColor:"#f7f7f7"}}>
                                   
                                    <div class="justify-content-center">                           

                                       

                                        <div class="card-body chge-hov" style={{backgroundColor:"#f7f7f7", padding:"1rem"}}>
                                        <div className='news-img' style={{width:"100%"}}>
                                    <img alt="..." src={x.featuredImage} />
                                    </div>
                                            <h2 className='Nwsovr text-left'>{x.htmlTitle + " by " + x.authorName}</h2>
                                            <div class="text-center">
                                                <p className='Nwsovrp text-left'>
                                                     {(x.postBody)?((x.postBody).replace(/&nbsp;/g, " ")).replace(/&amp;/g, "&").replace(/<\/?[^>]+(>|$)/g, ""):''}
                                                    </p>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </a>
                        </Col>
                    )}
                </Row>
            </div>
            <div className='text-center' style={{padding:"0"}}>
                {/* <Link to="/newsList">
                    <button className="btn btn-primary btn-md"> More News</button>
                </Link> */}
                <a href="https://channel-summit.com/blog" target='_blank'>
                    <button className="btn btn-primary btn-md"> More News</button>
                </a>                
            </div>
        </Card>
    );
};

export default Newssection;